export default __webpack_public_path__ + "images/37bbf045532cd9a77b651e81f86dd43d.png";